import { memo } from "react";
import { CreateContactForm } from "./CreateContactForm";
import type { CreateContactData } from "./CreateContactForm";
import { RightDrawer } from "@src/components/web/RightDrawer.web";

type ContactMode = "email" | "sms";

interface CreateContactPanelProps {
  visible: boolean;
  mode: ContactMode;
  onSave: (data: CreateContactData) => void;
  onClose: () => void;
  isSaving?: boolean;
}

export type { CreateContactData };

export const CreateContactModal = memo(({ visible, mode, onSave, onClose, isSaving }: CreateContactPanelProps) => {
  return (
    <RightDrawer visible={visible} onClose={onClose} title="Create new contact">
      <CreateContactForm mode={mode} onSave={onSave} isSaving={isSaving} hideHeader />
    </RightDrawer>
  );
});

CreateContactModal.displayName = "CreateContactModal";
